<template>
  <div class="box10">
    <pageTitle 
      :title="'<span>超多福利</span>&nbsp;&nbsp;赋能职场一路进阶'"
      text="解锁职业成长新机遇，全面支持您的每一步发展"
       />
    <div class="function-wrapper">
      <div class="fun-item">
        <div class="fun-title">
          <span class="title">人才输送</span>
          <img src="../../../assets/coursePage/harmony/box10/人才输送.png" alt="" />
        </div>
        <p>优先享受华为生态相关岗 位人才输送机会</p>
      </div>
      <div class="fun-item">
        <div class="fun-title">
          <span class="title">课程长期更新</span>
          <img src="../../../assets/coursePage/harmony/box10/终身课程.png" alt="" />
        </div>
        <p>一次学习，课程长期更新</p>
      </div>
      <div class="fun-item">
        <div class="fun-title">
          <span class="title">云课堂分享</span>
          <img src="../../../assets/coursePage/harmony/box10/大咖分享.png" alt="" />
        </div>
        <p>导师线上直播分享鸿蒙相关技术和能力</p>
      </div>
      <div class="fun-item">
        <div class="fun-title">
          <span class="title">就业指导</span>
          <img src="../../../assets/coursePage/harmony/box10/就业指导.png" alt="" />
        </div>
        <p>1V1 对学员进行简历和面试指导</p>
      </div>
    </div>
    <div class="award-wrapper">
      <img src="../../../assets/coursePage/harmony/box10/award.png" alt="" />
      <div>
        <p class="text1">免费考取《Harmony OS应用开发者高级认证》证书为求职加分</p>
        <p class="text2">学习鸿蒙内容 系统获得实用技术</p>
        <p class="text2">实战项目 提升鸿蒙技能</p>
        <p class="text2">讲师助力备考 督学答疑</p>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },

  data() {
    return {
      
    };
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
.box10 {
  font-family: PingFang SC;
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/harmony/box10/bg.png") no-repeat;
  background-size: cover;
  ::v-deep .course-title-box .course-title {
    span {
      color: #FF401A;
    }
  }
  .function-wrapper{
    margin: 60px auto 0;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
    width: 690px;
		.fun-item{
      box-sizing: border-box;
			width: 330px;
			height: 233px;
			background: #FFFFFF;
			box-shadow: 0 10px 30px 0 #FFEBFF;
			border-radius: 20px;
			border: 2px solid #FFFFFF;
			padding: 14px 14px 0 30px;
			margin-bottom: 30px;
			.fun-title{
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				.title{
					font-weight: 600;
					font-size: 32px;
					color: #FF401A;
				}
				img{
					width: 80px;
				}
			}
			p{
        font-size: 24px;
				color: #474D66;
			}
		}
	}
	.award-wrapper{
    margin: 0 auto;
    box-sizing: border-box;
		display: flex;
		flex-direction: row;
		width: 690px;
		height: 337px;
		border: 10px solid #FF401A;
		box-shadow: 0 10px 30px 0 #FFEBFF;
		border-radius: 30px;
		padding: 30px 60px 30px 30px;
		img{
			width: 180px;
			margin-right: 40px;
		}
		.text1{
			font-weight: 600;
			font-size: 30px;
			color: #FF401A;
			margin-bottom: 30px;
			line-height: 43px;
		}
		.text2{
			font-size: 24px;
      color: #474D66;
      line-height: 36px;
		}
	}
}
</style>
